<template>
  <div class="relative inline-block text-left">
    <div class="fixed inset-0 h-screen w-screen" v-if="isOpen">
      <div class="absolute inset-0 opacity-75" v-on:click="toggle"></div>
    </div>
    <div>
      <button
        @click="toggle"
        @focus="buttonHasFocus = true"
        @blur="buttonHasFocus = false"
        type="button"
        :class="[buttonClass]"
      >
        <slot name="trigger" :hasFocus="buttonHasFocus" :isOpen="isOpen"></slot>
      </button>
      <transition
        enter-active-class="transition ease-out duration-100"
        leave-active-class="transition ease-in duration-75"
        enter-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
      >
        <div
          class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-40 overflow-hidden"
          v-if="isOpen"
        >
          <slot name="dropdown"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    buttonClass: {
      type: String,
      default:
        "rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none z-0"
    }
  },
  data() {
    return {
      buttonHasFocus: false,
      isOpen: false
    };
  },
  mounted() {
    const onEscape = e => {
      if (!this.isOpen || e.key !== "Escape") {
        return;
      }
      this.isOpen = false;
    };
    document.addEventListener("keydown", onEscape);

    this.$on("hook:destroyed", () => {
      document.removeEventListener("keydown", onEscape);
    });
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
